document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("retreat-booking-form");
  if (!form) return;

  // Use Shopify's money format so currency respects the store's active locale/currency
  const moneyFormat =
    window.Shopify && window.Shopify.money_format
      ? window.Shopify.money_format
      : "{{amount}}";

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    // Fallback: use the store currency symbol from the page if available
    const amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace("{{amount}}", amount)
      .replace("{{amount_no_decimals}}", Math.round(cents / 100));
  }

  const destinationSelect = document.getElementById("destination-select");
  const roomSelect = document.getElementById("room-select");
  const totalPriceElement = document.getElementById("total-price");
  const addonsContainer = document.querySelector(".addons-checkboxes");
  const roomWarningInfo = document.getElementById("room-warning-info");

  let currentRooms = [];
  let availableAddons = [];

  // 1. Handle Destination Change
  destinationSelect.addEventListener("change", async function () {
    const handle = this.value;

    // Reset room select
    roomSelect.innerHTML = '<option value="">Loading rooms...</option>';
    roomSelect.disabled = true;
    currentRooms = [];

    if (!handle) {
      roomSelect.innerHTML =
        '<option value="">Please select a destination first</option>';
      return;
    }

    try {
      // Fetch rooms for this collection using the special JSON view
      const response = await fetch(`/collections/${handle}?view=json-rooms`);
      if (!response.ok) throw new Error("Network response was not ok");

      const rooms = await response.json();
      currentRooms = rooms;

      // Populate room select
      roomSelect.innerHTML = '<option value="">-- Select Room Type --</option>';

      if (rooms.length === 0) {
        roomSelect.innerHTML +=
          '<option value="" disabled>No rooms available for this retreat</option>';
      } else {
        rooms.forEach((room) => {
          const roomPrice = Number(room.price) || 0;

          roomSelect.innerHTML += `
            <option value="${room.id}" data-price="${roomPrice}">
              ${room.title} - ${formatMoney(roomPrice * 100)}
            </option>
          `;
        });
        roomSelect.disabled = false;
      }

      updatePrice();
    } catch (error) {
      console.error("Error fetching rooms:", error);
      roomSelect.innerHTML =
        '<option value="">Error loading rooms. Please try again.</option>';
    }
  });

  // Show/hide room warning info on room change
  roomSelect.addEventListener("change", function () {
    const selectedVariantId = this.value;
    const room = currentRooms.find(r => String(r.id) === String(selectedVariantId));
    const warning = room && room.warning_info;

    if (warning) {
      roomWarningInfo.textContent = warning;
      roomWarningInfo.classList.remove("hidden");
    } else {
      roomWarningInfo.textContent = "";
      roomWarningInfo.classList.add("hidden");
    }

    updatePrice();
  });


  // 3. Load Add-ons Dynamically
  async function loadAddons() {
    try {
      // Fetch all products, then filter by tag on client-side
      // This works even if the page is hidden
      const response = await fetch("/products.json?limit=250");
      if (!response.ok) throw new Error("Failed to load products");

      const data = await response.json();

      // Filter for products with 'retreat-addon' tag
      availableAddons = data.products
        .filter((product) => product.tags.includes("retreat-addon"))
        .map((product) => ({
          id: product.variants[0].id,
          title: product.title,
          price: parseFloat(product.variants[0].price), // Already in decimal format
          handle: product.handle,
          description:
            product.body_html?.replace(/<[^>]*>/g, "").substring(0, 100) || "",
          per_person: product.metafields?.addon?.per_person !== false, // default true
        }));

      renderAddonCheckboxes();
    } catch (error) {
      console.error("Error loading add-ons:", error);
      if (addonsContainer) {
        addonsContainer.innerHTML = `
          <p style="color: #666; font-style: italic;">
            Add-ons available upon request. Please mention in comments if interested.
          </p>
        `;
      }
    }
  }

  function renderAddonCheckboxes() {
    if (!addonsContainer || availableAddons.length === 0) return;

    addonsContainer.innerHTML = "";

    availableAddons.forEach((addon) => {
      const checkboxHtml = `
        <div class="checkbox-group">
          <input 
            type="checkbox" 
            id="addon_${addon.handle}" 
            class="addon-checkbox"
            data-variant-id="${addon.id}"
            data-price="${addon.price}"
            data-title="${addon.title}"
            data-per-person="${addon.per_person}"
          >
          <label for="addon_${addon.handle}">
            ${addon.title} (+${formatMoney(addon.price * 100)}${addon.per_person ? "/person" : ""})
          </label>
        </div>
      `;
      addonsContainer.insertAdjacentHTML("beforeend", checkboxHtml);
    });

    document.querySelectorAll(".addon-checkbox").forEach((cb) => {
      cb.addEventListener("change", updatePrice);
    });
  }

  // 4. Handle Add-ons and Room Change for Price Update
  roomSelect.addEventListener("change", updatePrice);

  const addonCheckboxes = document.querySelectorAll(
    'input[type="checkbox"][id^="addon_"]',
  );
  addonCheckboxes.forEach((cb) => cb.addEventListener("change", updatePrice));

  function updatePrice() {
    let total = 0;

    // Room price
    const selectedRoomOption = roomSelect.options[roomSelect.selectedIndex];
    if (selectedRoomOption && selectedRoomOption.value) {
      total += parseFloat(selectedRoomOption.dataset.price) || 0;
    }

    // Add-ons (flat price regardless of guest count)
    document.querySelectorAll(".addon-checkbox:checked").forEach((checkbox) => {
      total += parseFloat(checkbox.dataset.price) || 0;
    });

    totalPriceElement.textContent = formatMoney(total * 100);
  }

  // 4. Form Submission
  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    const submitBtn = form.querySelector('button[type="submit"]');
    const originalText = submitBtn.textContent;
    submitBtn.textContent = "Processing...";
    submitBtn.disabled = true;

    // Validation (basic HTML5 validation triggers first, this is extra)
    if (!destinationSelect.value || !roomSelect.value) {
      alert("Please select a destination and room type.");
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
      return;
    }

    const variantId = roomSelect.value;
    if (!variantId || variantId === "null" || variantId === "undefined") {
      alert(
        "The selected room is not available for purchase. Please check that the room product is active and has a valid variant in Shopify.",
      );
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
      return;
    }

    // Prepare Cart Item
    // We need a product ID to add to cart.
    // In this model, we are simulating adding the "Room Product" variant to the cart directly?
    // OR we are adding a generic "Booking" product.
    // The Room Dropdown values are PRODUCT IDs for the room types.
    // However, those products are likely "Room Type" products (e.g. "Shared Room") which might be generic.
    // A better approach for this phase, since we don't have separate booking products per destination yet:
    // We will add the Room Product Variant to the cart.
    // WE NEED TO FIND THE VARIANT ID. The JSON returns Product ID.
    // We should probably update the JSON to return the First Variant ID if these are simple products.

    // NOTE: For now, I'll assume the room ID in the dropdown is the VARIANT ID or I need to fetch it.
    // Let's fallback to: The dropdown option value SHOULD be the variant ID to be added to cart.
    // Update collection.json-rooms.liquid to output `product.selected_or_first_available_variant.id`.

    // variantId already validated above

    // Gather properties
    const formData = new FormData(form);
    const properties = {};
    for (const [key, value] of formData.entries()) {
      if (key.startsWith("properties[")) {
        // properties[Name] -> Name
        const propName = key.match(/properties\[(.*?)\]/)[1];
        if (value.trim() !== "") {
          properties[propName] = value;
        }
      }
    }

    const items = [
      {
        id: variantId,
        quantity: 1,
        properties: properties,
      },
    ];

    // Add selected add-ons as separate line items
    document.querySelectorAll(".addon-checkbox:checked").forEach((checkbox) => {
      items.push({
        id: checkbox.dataset.variantId,
        quantity: 1,
        properties: {
          "Add-on for": "Retreat Booking",
          "Booking ID": variantId,
        },
      });
    });

    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: items }),
      });

      if (!response.ok) {
        let errMsg = "Failed to add to cart";
        try {
          const errData = await response.json();
          errMsg = errData.description || errData.message || errMsg;
        } catch (_) {}
        throw new Error(errMsg);
      }

      // Redirect to cart
      window.location.href = "/cart";
    } catch (error) {
      console.error("Error adding to booking:", error);
      alert(
        "We're sorry, we couldn't process your booking.\n\n" +
          "\n\nThis may be a temporary issue on our end. Please contact us and we'll get it sorted:\n\n" +
          "📧 hello@amretreat.com\n" +
          "📝 Or use our Contact page at /pages/contact",
      );
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
    }
  });

  // Initialize: Load add-ons on page load
  loadAddons();
});
